import type {ComponentProps} from "react";
import Popup from "@atlaskit/popup";

export function AnankePopup(props: ComponentProps<typeof Popup>) {
    return <Popup {...props} />;
}
